export default "__VITE_ASSET__CBOG$G3P__"